export const HTTP_STATUS_CODE = {
    OK: 200,
    UNAUTHORIZED: 401,
};
